import { BUYER_ANALYTICS_EVENTS } from "../../constants/automapAnalyticsEvents";
import { trackBuyerEvent } from "../buyerAnalytics";

export function trackBuyerGuestMergeStarted(slug, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.BUYER_GUEST_MERGE_STARTED, {
    clientViewSlug: slug,
    ...extra,
  });
}

export function trackBuyerGuestMergeCompleted(slug, merged = {}, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.BUYER_GUEST_MERGE_COMPLETED, {
    clientViewSlug: slug,
    likesMerged: merged.likes || 0,
    savedSearchesMerged: merged.savedSearches || 0,
    quizIntentMerged: Boolean(merged.quizIntent),
    financingPrefsMerged: Boolean(merged.financingPrefs),
    compareListingIdsMerged: merged.compareListingIds || 0,
    ...extra,
  });
}

export function trackBuyerGuestMergeFailed(slug, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.BUYER_GUEST_MERGE_FAILED, {
    clientViewSlug: slug,
    ...extra,
  });
}
